import styled from 'styled-components';
import { theme } from '../../../styles/theme';

export const Container = styled.div`
  background: ${theme.colors.black};
  padding: 3.5rem 8%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const StatItem = styled.div`
  text-align: center;
  position: relative;

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    right: 0;
    top: 20%;
    bottom: 20%;
    width: 1px;
    background: rgba(255, 255, 255, 0.1);

    @media (max-width: 600px) {
      display: none;
    }
  }
`;

export const StatNum = styled.div`
  font-family: ${theme.fonts.display};
  font-size: clamp(2rem, 4vw, 2.8rem);
  font-weight: 800;
  color: ${theme.colors.orange};
`;

export const StatDesc = styled.div`
  color: rgba(255, 255, 255, 0.45);
  font-size: 0.85rem;
  margin-top: 0.3rem;
`;
